import { API_URL } from "../../config/connect";

/**
 * Fetch districts from the Location API
 * @param {number} regionId - Optional region ID to filter districts
 * @param {number} countryId - Optional country ID to filter districts (used if regionId is not provided)
 * @returns {Promise<Array>} Array of districts
 */
export async function getDistricts(regionId = null, countryId = null) {
    let endpoint = `${API_URL}/api/v1/districts`;
    const params = [];
    
    if (regionId) {
        params.push(`region_id=${regionId}`);
    } else if (countryId) {
        params.push(`country_id=${countryId}`);
    }
    
    if (params.length > 0) {
        endpoint += `?${params.join('&')}`;
    }

    try {
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const result = await response.json();
        return result.districts || [];
    } catch (error) {
        console.error('Failed to fetch districts:', error);
        throw error;
    }
}

